// Follows GoodsService.buildStepSummary: configured tiers -> global min/max -> active parent discount.
export function priceMoney(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return '—'
  return (Math.round((n + Number.EPSILON * Math.max(1, Math.abs(n))) * 100) / 100).toFixed(2)
}

export function explainStepPrices(goods = {}, children = [], rate = 0.14, now = Date.now() / 1000) {
  const discountRate = Math.max(0, Math.min(100, Number(goods.discountRate) || 0))
  const expired = Number(goods.discountExpireTime) > 0 && Number(goods.discountExpireTime) <= now
  const active = discountRate > 0 && !expired
  const factor = active ? 1 - discountRate / 100 : 1
  const percent = Number((factor * 100).toFixed(6)) + '%'
  const cnyValues = []
  const usdValues = []
  const sources = children.length ? children : [{ ...goods, stepPrices: [] }]
  const explain = value => ({ original: priceMoney(value), discount: priceMoney(value * (1 - factor)), final: priceMoney(value * factor) })
  const rows = sources.map(child => {
    const configured = (child.stepPrices || []).filter(step => step.priceCny != null)
    const steps = configured.length ? configured : child.shopPrice != null ? [{
      minStepnum: '—',
      maxStepnum: '—',
      priceCny: child.shopPrice,
      // Child base-price fallback in the list summary uses CNY × exchange rate.
      priceUsd: children.length ? Number(child.shopPrice) * rate : (child.foreignPriceUsd == null ? Number(child.shopPrice) * rate : child.foreignPriceUsd)
    }] : []
    return {
      ...child,
      baseFallback: !configured.length,
      steps: steps.map(step => {
        const cny = Number(step.priceCny)
        const usd = step.priceForeignCny != null ? Number(priceMoney(Number(step.priceForeignCny) * rate)) : (step.priceUsd == null ? Number(priceMoney(cny * rate)) : Number(step.priceUsd))
        cnyValues.push(cny)
        usdValues.push(usd)
        return { ...step, cny: explain(cny), usd: explain(usd) }
      })
    }
  })
  const range = (values, multiplier) => values.length ? priceMoney(Math.min(...values) * multiplier) + '～' + priceMoney(Math.max(...values) * multiplier) : '—'
  return {
    active,
    expired,
    discountRate,
    percent,
    children: rows,
    originalCnyRange: range(cnyValues, 1),
    originalUsdRange: range(usdValues, 1),
    cnyRange: range(cnyValues, factor),
    usdRange: range(usdValues, factor)
  }
}
